(function () {
  const DRAWER_SEL = 'mobile-menu > header-drawer';
  const LABEL_SPAN_SEL = 'div.header__mobile__right > div:nth-child(1) > button > div > span';
  const CLASS_WHEN_OPEN = 'inverted-close-menu';

  function findDrawer(){ return document.querySelector(DRAWER_SEL); }
  function findSpan(){ return document.querySelector(LABEL_SPAN_SEL) || document.querySelector('.header__mobile__right button span'); }

  function isOpen(drawer){
    return drawer && (
      drawer.classList.contains('is-open') ||
      drawer.classList.contains('active') ||
      drawer.hasAttribute('open') ||
      drawer.getAttribute('aria-hidden') === 'false'
    );
  }

  function applyState() {
    const drawer = findDrawer();
    const span = findSpan();
    if (!drawer || !span) {
      console.warn('[label swap] missing node(s). drawer?', !!drawer, 'span?', !!span);
      return;
    }
    const btn = span.closest('button');
    const open = isOpen(drawer);

    // swap label text
    const nextText = open ? 'Close' : 'Menu';
    if (span.textContent !== nextText) {
      console.log('[label swap] label ->', nextText);
      span.textContent = nextText;
    }

    // a11y
    if (btn) {
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      btn.setAttribute('aria-expanded', String(open));

      // toggle styling class
      btn.classList.toggle(CLASS_WHEN_OPEN, open);
      console.log('[label swap] toggle class', CLASS_WHEN_OPEN, '=>', open);
    }

    console.log('[label swap] drawer classes:', drawer.className);
  }

  function init() {
    const drawer = findDrawer();
    if (!drawer) {
      console.warn('[label swap] drawer not found initially; will poll for 5s');
      let tries = 0;
      const iv = setInterval(() => {
        tries++;
        if (findDrawer()) { clearInterval(iv); applyState(); observe(); }
        if (tries > 10) clearInterval(iv);
      }, 500);
    } else {
      applyState();
      observe();
    }
  }

  function observe() {
    const drawer = findDrawer();
    if (!drawer) return;
    new MutationObserver(applyState).observe(drawer, { attributes:true, attributeFilter:['class','open','aria-hidden'] });
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-drawer="hamburger-{{ section.id }}"], [data-drawer-close], .drawer__underlay')) {
        setTimeout(applyState, 0);
      }
    });
  }

  (document.readyState === 'loading')
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
